import { Component, OnInit } from '@angular/core';
import { MenuStylesService } from 'src/app/services/menu-styles.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  
  menuStyle: any;
  constructor(private styleMenuService: MenuStylesService) { }

  ngOnInit(): void {
    this.styleMenuService.castStyleMenu.subscribe(menuStyle => this.menuStyle = menuStyle);
  }

}
